import(/* webpackMode: "eager" */ "/workspace/src/app/FLP-connect/page.js");
